import React from 'react';
import Button from '../Button';
import ConsentBanner from '../ConsentBanner';
import LegalLinks from '../LegalLinks';
import MarketingPanel from './MarketingPanel';
import { useToast } from '../Toast';
import { useAuth } from '../../context/AuthContext';
import { useCheckEmail } from '../../hooks/useCheckEmail';
import s from './login.module.css';
import c from './checkEmail.module.css';

// What a signed-in teacher whose address is not confirmed sees instead of the
// app (#566): the address, Resend, "I've verified" and Sign out, and nothing
// else. `SignInGate` in src/App.jsx decides to draw it; the rule is
// src/domain/signIn.js; what the buttons do is src/hooks/useCheckEmail.js, and
// what they answer goes to the toast (#568).
//
// Drawn in the sign-in page's frame rather than the app's. The teacher is not
// in the app yet, and a sidebar of places they cannot go would be a promise
// this screen then breaks.
//
// Not an MMS parity element: MMS asks for a card at sign-up, so it has no
// unverified-trial problem to solve. The copy is ours (#566).
export default function CheckEmailScreen() {
  const { user, logout, resendVerification, refreshVerification } = useAuth();
  const toast = useToast();
  const { sending, checking, resend, check } = useCheckEmail({
    email: user?.email,
    resend: resendVerification,
    refresh: refreshVerification,
    say: toast,
  });

  return (
    <div className={s.split}>
      <MarketingPanel />
      <div className={s.formPane}>
        <div className={s.formWrap}>
          <div className={s.formHead}>
            <div className={s.markMedium} />
            <h1 className={s.formTitle}>Check your email</h1>
            <p className={s.formLead}>
              {/* Named, because a typo in the address is the usual reason the
                  email never arrives, and it is invisible otherwise. */}
              We sent a link to <strong className={c.address}>{user?.email}</strong>.
              Open it to confirm your address, then come back here.
            </p>
          </div>

          <div className={c.actions}>
            <Button variant="primary" size="lg" className={s.submit} loading={checking} onClick={check}>
              I&rsquo;ve verified
            </Button>
            <Button variant="secondary" size="lg" className={s.submit} loading={sending} onClick={resend}>
              Resend email
            </Button>
          </div>

          <div className={s.switch}>
            Wrong address?{' '}
            <button type="button" className={s.switchButton} onClick={logout}>
              Sign out
            </button>
            {' '}and sign up again.
          </div>

          {/* As on the sign-in page. A new email sign-up is drawn this screen at
              /welcome (#754), where its conversion is due; measurement runs
              unless declined (#755), so the notice and the way to decline —
              Cookie settings, under it — have to be here. The banner renders
              nothing once answered. */}
          <ConsentBanner inline />
          <LegalLinks cookieSettings />
        </div>
      </div>
    </div>
  );
}
